import classNames from 'classnames'

import { Button } from '../uiLib'


const ElectronicServiceValidSubscription = ({ t, loading, handleSubmit, _handleSubmit }) => (
  <div className="content">
    <div>
      <form onSubmit={handleSubmit(_handleSubmit)} className="ma-contact-form columns">
        <div className="m-b-md">
          <Button
            outlined
            className={classNames({
              'is-default': true,
              'is-loading': loading
            })}
            btType="default"
          >
            {t('common:open-electronic-service')}
          </Button>
        </div>
      </form>

    </div>
    <div>
     <br />
      <p>{t('common:esi-content-15')}</p>      
    </div>
  </div>
)

export default ElectronicServiceValidSubscription



// WEBPACK FOOTER //
// ./components/ElectronicService/WithValidSubscription.js